/**
 * SELECT EXCEL FILE VIEW TEMPLATE
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import LoadingSpinner from '../../../reusable/LoadingSpinner/LoadingSpinner.index.jsx';

import { GETTING_STARTED_LINK } from '../../../constants';

export default class DashboardNoActiveEntities extends React.Component {

    render() {

        let availableThirdParties = this.props.data.subscription - this.props.data.inactive - this.props.data.active;

        return (
            <div className="start-page">

                <div className="start-page__info-panels">

                    <div className="start-page__info-panels--row">
                        {/*add panel*/}
                        <div className="info-panel add">

                            <div className="info-panel__header">
                                <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.add"/>
                            </div>

                            <div className="info-panel__details">
                                <LoadingSpinner
                                    isInner={true}
                                    isVisible={ this.props.data.spinners.addSpinner }
                                />
                                <div className="details-wrapper">
                                    <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.add.t1"/>
                                    &nbsp;
                                    <span className="text-highlight">{availableThirdParties ? availableThirdParties : ''}</span>
                                    &nbsp;
                                    <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.add.t2"/>
                                    &nbsp;
                                    <span className="text-highlight">{this.props.data.subscription}.</span>
                                </div>

                            </div>

                            <div className="info-panel__actions">
                                <div className="action-link">
                                    <Link to="/upload">
                                        <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.add.upload"/>
                                    </Link>
                                </div>
                            </div>

                        </div>

                        {/*activate panel*/}
                        <div className="info-panel activate">

                            <div className="info-panel__header">
                                <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.activate"/>
                            </div>

                            <div className="info-panel__details">
                                <LoadingSpinner
                                    isInner={true}
                                    isVisible={ this.props.data.spinners.activateSpinner }
                                />
                                <div className="details-wrapper">
                                    <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.activate.t1"/>
                                    &nbsp;
                                    <span className="text-highlight">{this.props.data.inactive}</span>
                                    &nbsp;
                                    <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.activate.t2"/>
                                </div>

                            </div>

                            <div className="info-panel__actions">
                                <div className="action-link">
                                    <Link to="/review-companies">
                                        <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.activate.review"/>
                                    </Link>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="start-page__info-panels--row">
                        {/*share panel*/}
                        <div className="info-panel share">

                            <div className="info-panel__header">
                                <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.share"/>
                            </div>

                            <div className="info-panel__details">
                                <LoadingSpinner
                                    isInner={true}
                                    isVisible={ this.props.data.spinners.shareSpinner }
                                />
                                <div className="details-wrapper">
                                    <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.share.t1"/>
                                    &nbsp;
                                    <span className="text-highlight">{this.props.data.rss}</span>
                                    &nbsp;
                                    <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.share.t2"/>
                                </div>
                            </div>

                            <div className="info-panel__actions">
                                <div className="action-link">
                                    <Link to="/feeds">
                                        <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.share.manage"/>
                                    </Link>
                                </div>
                                <div className="action-link">
                                    <Link to="/add-new-feed">
                                        <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.share.add"/>
                                    </Link>
                                </div>
                            </div>

                        </div>

                        {/*manage panel*/}
                        <div className="info-panel manage">

                            <div className="info-panel__header">
                                <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.manage"/>
                            </div>

                            <div className="info-panel__details">
                                <LoadingSpinner
                                    isInner={true}
                                    isVisible={ this.props.data.spinners.manageSpinner }
                                />
                                <div className="details-wrapper">
                                    <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.manage.t1"/>
                                    &nbsp;
                                    <span className="text-highlight">{this.props.data.active}</span>
                                    &nbsp;
                                    <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.manage.t2"/>
                                </div>
                            </div>

                            <div className="info-panel__actions">
                                <div className="action-link">
                                    <Link to="/manage-third-parties">
                                        <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.manage.add"/>
                                    </Link>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>


                <div className="start-page__know-more">

                    <div className="know-more__container">
                        <FormattedMessage id="Dashboard_CoreFunctionality_UIText_dashboard.knowMore.t1"/>
                        &nbsp;
                        <a target="_blank"
                           href={this.props.helpUrlRoot + GETTING_STARTED_LINK}>
                            <FormattedMessage id="Dashboard_Charts_UIText_dashboard.knowMore.t2"/>
                            <sup>&reg;</sup>
                        </a>
                    </div>


                </div>

            </div>
        );
    }


}


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/DashboardNoActiveEntities/DashboardNoActiveEntities.jsx